import { FunctionComponent } from 'react'
import Dialog from '@/components/_custom/Dialog/Dialog'
import styles from './confirmAssociateStaffDialog.module.scss'
import DialogHeader from '@/components/_custom/DialogHeader/DialogHeader'
import DialogBody from '@/components/_custom/DialogBody/DialogBody'
import { useTranslation } from 'react-i18next'
import ButtonTextIcon from '@/components/_custom/Buttons/ButtonTextIcon/ButtonTextIcon'
import { useMutation } from '@apollo/client'
import { useAuth } from '@/modules/context/AuthContext'
import { STAFF_LINKS } from '@/modules/API/daycare/staffLinkHandler'
import { useNotification } from '@/modules/context/NotificationContext.tsx'

interface ConfirmAssociateStaffDialogProps {
    open: boolean
    closeDialog: () => void
    name: string
    email: string
    refetchAllSuggest: () => void
}

const ConfirmAssociateStaffDialog: FunctionComponent<ConfirmAssociateStaffDialogProps> = ({
    open,
    closeDialog,
    name,
    email,
    refetchAllSuggest
}) => {
    const { t } = useTranslation()

    const { user } = useAuth()

    const { showNotificationSuccess, showNotificationError } = useNotification()

    const [addStaff] = useMutation(STAFF_LINKS, {
        variables: {
            daycare_id: user?.currentDaycare?.id,
            email: email,
            from_suggest: true
        },
        onCompleted: () => {
            showNotificationSuccess(t('addStaffSuccess'))

            refetchAllSuggest()

            closeDialog()
        },
        onError: () => {
            showNotificationError(t('addStaffError'))
        }
    })

    return (
        <Dialog open={open} handleClose={closeDialog} className={styles.DialogAdd}>
            <DialogHeader title={t('associateStaff')}></DialogHeader>
            <DialogBody className={styles.DialogBody}>
                <p className={styles.Text}>{t('associateStaffMessage')}</p>
                {user?.daycares && user?.daycares.length > 1 && (
                    <>
                        <p className={styles.Text}>
                            {user?.currentDaycare?.name} - {user?.currentDaycare?.city}
                        </p>
                        <br />
                    </>
                )}
                <p className={styles.TextFamily}>
                    {name} {email && `- ${email}`}
                </p>
                <p className={styles.Text}>{t('noRollBack')}</p>
                <div className={styles.ButtonContainer}>
                    <ButtonTextIcon type={'cancel'} onClick={closeDialog} className={styles.Button} />
                    <ButtonTextIcon type={'confirm'} onClick={addStaff} className={styles.Button} />
                </div>
            </DialogBody>
        </Dialog>
    )
}

export default ConfirmAssociateStaffDialog
